import FeaturesShow from "../components/features/Show";

export default [
  { name: 'Features', path: '/features', component: FeaturesShow,  }
]
